var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialRange)?_c('v-daterange',{attrs:{"presets":_vm.dateRangeOptions ? _vm.dateRangeOptions.presets : undefined,"start-label":"Any","end-label":"Now","separator-label":"-","highlight-color":"blue lighten-3","display-format":"MM/DD/YY","input-props":{
                    appendIcon: 'insert_invitation'
                },"value":_vm.initialRange},on:{"input":_vm.onDateRangeChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }